module.exports = __webpack_public_path__ + "img/icon_logo.03a64604.png";